function HouseCountReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16"> HouseCountReport</div>
      </>
    );
  }
  
  export default HouseCountReport;